import type { IntegrationLoginProvider } from '~kui/types/auth';

// cross-tab notification of auth state changes (same-origin only)
export const AUTH_BROADCAST_CHANNEL = 'auth';
export const AUTH_LOGGED_OUT_MESSAGE = 'logged-out';
export const AUTH_ACCOUNT_SWITCHED_MESSAGE = 'account-switched';
// carries the path the switching tab lands on, so a tab showing the other role's pages follows it there
export interface AuthAccountSwitchedMessage {
  type: typeof AUTH_ACCOUNT_SWITCHED_MESSAGE;
  path: string;
}
// sent by a tab about to switch account, so the others hold their requests until it is done
export const AUTH_ACCOUNT_SWITCH_PENDING_MESSAGE = 'account-switch-pending';
// a tab's answers to a pending switch: it has stopped sending requests, then the ones it had out have answered
export const AUTH_ACCOUNT_SWITCH_HOLDING_MESSAGE = 'account-switch-holding';
export const AUTH_ACCOUNT_SWITCH_SETTLED_MESSAGE = 'account-switch-settled';
// the pending switch was refused, so the tabs holding for it let their requests go
export const AUTH_ACCOUNT_SWITCH_REFUSED_MESSAGE = 'account-switch-refused';
export interface AuthAccountSwitchPendingMessage {
  type: typeof AUTH_ACCOUNT_SWITCH_PENDING_MESSAGE | typeof AUTH_ACCOUNT_SWITCH_REFUSED_MESSAGE;
  switchId: string;
  tabId: string;
}
export interface AuthAccountSwitchAnswerMessage {
  type: typeof AUTH_ACCOUNT_SWITCH_HOLDING_MESSAGE | typeof AUTH_ACCOUNT_SWITCH_SETTLED_MESSAGE;
  switchId: string;
  tabId: string;
}
// set in the tab that switched account, which hears its own message and is already navigating away
export const AUTH_ACCOUNT_SWITCHED_HERE_STATE = 'auth-account-switched-here';
// the account being switched to, from its pick until the switch is refused or the landing page loads
export const AUTH_ACCOUNT_SWITCH_IN_FLIGHT_STATE = 'auth-account-switch-in-flight';
export interface AuthAccountSwitchInFlight {
  schoolName: string;
}

/**
 * Marks the admin second-factor mutations, whose UNAUTHENTICATED means the pending sign-in lapsed.
 * The step answers that in place, so the global handler must not reload the login page underneath it.
 */
export const ADMIN_MFA_OPERATION_CONTEXT = { answersUnauthenticated: true } as const;

// how an email was proved, as reported on the unified auth analytics events
export const AuthAnalyticsMethod = {
  EmailOtp: 'email_otp',
  EmailPassword: 'email_password',
  // a social sign-in whose provider is not known, as on a refused OAuth exchange
  Social: 'social',
} as const;

// a social sign-in reports `social_<provider>`, as the OAuth callback does; an integration provider
// sign-in reports the provider, as the provider login page does
export type AuthAnalyticsMethodValue = typeof AuthAnalyticsMethod[keyof typeof AuthAnalyticsMethod] | `social_${string}` | IntegrationLoginProvider;

// non-logged in users only
export const AUTH_ROUTE_TYPE_GUEST = 'guest';
// logged in user only
export const AUTH_ROUTE_TYPE_AUTHENTICATED = 'authenticated';
// both logged in and guest users
export const AUTH_ROUTE_TYPE_NONE = 'none';

// manage authenticated page types
// export const AUTH_ROUTE_TYPE_MANAGE_AUTHENTICATED_ADMINISTER = 'manage_authenticated_administer';
// export const AUTH_ROUTE_TYPE_MANAGE_AUTHENTICATED_VIEW_REPORTS = 'manage_authenticated_view_reports';
// export const AUTH_ROUTE_TYPE_MANAGE_AUTHENTICATED_EDIT_STUDENTS = 'manage_authenticated_edit_students';
// export const AUTH_ROUTE_TYPE_MANAGE_AUTHENTICATED_VIEW_STUDENTS = 'manage_authenticated_view_students';
